var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@3e4b78253969c3de7563dd49e1145d7067581c7f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@3e4b78253969c3de7563dd49e1145d7067581c7f"};
      